import { IIndexable, IncludedType } from 'core-ts-types';
import { IUsersource, Usersource } from 'utility-ts-datasource';
import { ILocation } from '../types/appt_interfaces';

export interface IAlternateAppointmentTimesUsersourceModel {
  availability: string;
  selectedLocation: ILocation;
}

export type TAlternateAppointmentTimesUsersource = IncludedType<
  Usersource<IAlternateAppointmentTimesUsersourceModel>,
  IAlternateAppointmentTimesUsersourceModel
>;

export const AlternateAppointmentTimesUsersourceFactory: () => TAlternateAppointmentTimesUsersource =
  (): TAlternateAppointmentTimesUsersource => {
    return new Usersource<IAlternateAppointmentTimesUsersourceModel>({
      availability: '',
      selectedLocation: {} as ILocation
    }) as TAlternateAppointmentTimesUsersource;
  };



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/usersources/alternate_appointment_times_usersource.ts